module.exports = __webpack_public_path__ + "static/img/0.510154a8.jpg";